import { createText, createLine } from './helpers';

export const companyBranded = () => ({
  id: 'company-branded',
  name: 'Company Branded',
  thumbnail: '/assets/diploma-templates/07_example.webp',
  data: {
    elements: [
      createText({
        text: 'CERTIFICATE',
        left: 147,
        top: 238,
        fontSize: 64,
        fontFamily: 'EB Garamond',
        width: 500,
        color: '#3d5a6b',
        fontWeight: 'bold'
      }),
      createText({
        text: 'FOR YOU APPRECIATION',
        left: 222,
        top: 325,
        fontSize: 20,
        fontFamily: 'EB Garamond',
        width: 350,
        color: '#3d5a6b',
        fontWeight: 'bold'
      }),
      createText({
        text: 'THE CERTIFICATE IS PROUDLY PRESENTED TO:',
        left: 172,
        top: 448,
        fontSize: 14,
        fontFamily: 'EB Garamond',
        width: 450,
        color: '#3d5a6b'
      }),
      createText({
        text: '{learner_name}',
        left: 85,
        top: 554,
        fontSize: 52,
        fontFamily: 'Lato',
        width: 623,
        color: '#3d5a6b'
      }),
      createLine({ left: 147, top: 615, width: 500, color: '#3d5a6b' }),
      createText({
        text: '{program_description}',
        left: 147,
        top: 662,
        fontSize: 12,
        fontFamily: 'Lato',
        width: 500,
        color: '#666666',
        fontStyle: 'italic'
      }),
      createText({
        text: 'Jessica Iskandar',
        left: 97,
        top: 842,
        fontSize: 16,
        fontFamily: 'Lato',
        width: 200,
        color: '#3d5a6b'
      }),
      createLine({ left: 122, top: 842, width: 150, color: '#3d5a6b' }),
      createText({
        text: 'Managing Director',
        left: 97,
        top: 865,
        fontSize: 12,
        fontFamily: 'Lato',
        width: 200,
        color: '#666666'
      }),
      createText({
        text: 'Amanda Malopo',
        left: 497,
        top: 842,
        fontSize: 16,
        fontFamily: 'Lato',
        width: 200,
        color: '#3d5a6b'
      }),
      createLine({ left: 522, top: 842, width: 150, color: '#3d5a6b' }),
      createText({
        text: 'Head Coordinator',
        left: 497,
        top: 865,
        fontSize: 12,
        fontFamily: 'Lato',
        width: 200,
        color: '#666666'
      })
    ],
    backgroundColor: '#ffffff',
    backgroundImage: {
      url: '/assets/diploma-templates/backgrounds/07_background.svg',
      key: null
    }
  }
});
